import React from "react";
import CoverParticles from "./Particles";
import "../assets/styles/header.sass";

import { ReactComponent as Twitter } from "../assets/images/004-twitter.svg";
import { ReactComponent as Github } from "../assets/images/005-github.svg";
import { ReactComponent as Youtube } from "../assets/images/007-youtube.svg";
import { ReactComponent as Linkedin } from "../assets/images/006-linkedin.svg";

const Header = () => (
  <header>
    <CoverParticles />
    <div className="header-content">
      <div className="header-text">
        <h1>
          Hello! I'm <span>Jorge Durango</span>
        </h1>
        <h3>Freelance Web Developer</h3>
      </div>

      <div className="social">
        <ul>
          <li>
            <a
              href="https://twitter.com/duacos"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter />
            </a>
          </li>
          <li>
            <a
              href="https://github.com/duacos"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Github />
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/channel/UCFmGcSriFLqhfZlZTYPIv2Q/videos"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Youtube />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/jorge-durango-85350417b/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Linkedin />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>
);

export default Header;
